
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../_services';
import { Observable, UnsubscriptionError, Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    moduleId: module.id,
    selector: 'notification',
    templateUrl: 'notification.component.html',
    styleUrls: ["notification.component.css"]
})

export class NotificationComponent {
    unseenNotifications: Observable<any[]>;
    unseenNotifications1 = [];
    subs = new Subscription();
    currentUserId = localStorage.getItem('currentUserId');

    constructor(private router: Router,
        private afs: AngularFirestore,
        private notificationService: NotificationService) {

        this.unseenNotifications = this.notificationService.getUnseenNotifications();
        this.subs.add(this.unseenNotifications.subscribe(data => {
            this.unseenNotifications1 = data.sort(function (a, b) {
                a = a.modifyDate;
                b = b.modifyDate;
                return a < b ? 1 : a > b ? -1 : 0;
            });

        }))


    }
    ngOnInit() {

    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    seeNotif(notification) {
        this.afs.collection('users').doc(this.currentUserId).collection('notifications').ref.where('isUnseen', '==', true)
            .get().then((snap => {
                if (snap)
                    snap.forEach(unseen => {
                        unseen.ref.update({ isUnseen: false });
                    })

            })).then(() => {

                this.router.navigate([notification.action])
            })
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/notification/notification.component.ts